angular.module('leanlaw').controller('MatterAccessCtrl', ['$rootScope', '$scope', '$q', '$http', '$timeout', 'leanLawApi', '$state', 'userService', 'accountingService', 'lists', 'alerts', 'ModalService', 'leanLawAuth', 'tracking', function ($rootScope, $scope, $q, $http, $timeout, leanLawApi, $state, userService, accountingService, lists, alerts, ModalService, leanLawAuth, tracking) {
  $scope.newUser = {};
  $scope.rateGroups = [];
  $scope.invoiceTemplates = [];
  $scope.accounting = {
    connected: false
  };
  $scope.trust = {};
  $scope.lists = lists;
  $scope.sort = 'account.name';
  $scope.domain = `${leanLawAuth.domain}/v1`;
  $scope.reverse = false;
  $scope.updatingWIPRates = false;
  $scope.originationTotal = 0;
  $scope.invoiceTemplateDisplayName = '';
  let _initialBillingType;
  let _showBillingType;
  let _rateChanged = false;
  let rateTableOpenTime = null;
  $scope.contingencyFeeError = function () {
    if ($scope.matter?.billing?.type !== 'contingency') return '';
    const val = $scope.matter?.contingencyFeePercentage;
    if (val == null || val === '') return '';
    if (val < 0 || val > 100) {
      return 'Enter a number between 0 and 100 with up to 8 decimals';
    }
    if (val !== 0 && val < 0.00000001) {
      return 'Enter a number between 0 and 100 with up to 8 decimals';
    }
    const parts = String(val).split('.');
    if (parts[1] && parts[1].length > 8) {
      return 'Enter a number between 0 and 100 with up to 8 decimals';
    }
    return '';
  };
  $scope.isContingencyFeeInvalid = function () {
    return $scope.matter?.billing?.type === 'contingency' && !!$scope.contingencyFeeError();
  };
  activate();

  // Track rate table opened when Billing and Rates tab is opened
  userService.me().then(me => {
    rateTableOpenTime = Date.now();
    if (tracking) {
      tracking.event('Rate Table', 'Opened', {
        accountId: me.company?.id,
        entryPoint: 'matter'
      });
    }
  });
  $scope.addSelf = function () {
    $scope.saving = true;
    $scope.matter.assign().then(() => {
      $state.go('.', {}, {
        reload: true
      });
    }).finally(() => {
      $scope.saving = false;
    });
  };
  $scope.removeSelf = function () {
    $scope.matter.users.splice($scope.matter.users.indexOf($scope.user), 1);
    $scope.save().then(() => {
      $state.go('.', {}, {
        reload: true
      });
    });
  };
  $scope.billingTypeDescription = () => {
    if ($scope.matter.billing && (_showBillingType || _initialBillingType !== $scope.matter.billing.type)) {
      _showBillingType = true;
      return lists.billingTypes.find(t => t.id === $scope.matter.billing.type).description;
    }
  };
  $scope.setOriginating = function (user, value) {
    user.originating = value;
    $scope.billingForm.$setDirty();
  };
  $scope.setInvoiceTemplateName = function () {
    if ($scope.matter.invoiceTemplate && Object.keys($scope.matter.invoiceTemplate).length > 0) {
      $scope.invoiceTemplateDisplayName = $scope.matter.invoiceTemplate.name;
    } else {
      $scope.invoiceTemplateDisplayName = $scope.invoiceTemplates.length ? 'Using Firm Default' : 'Using Firm Default (Legacy Version)';
    }
  };
  $scope.save = function (saveAllMatters) {
    // Validate rates
    const usersWithZeroRate = $scope.matter.users.filter(user => (!user.rate || user.rate.amount === 0) && user.account && user.account.role !== 'accountant');
    if (usersWithZeroRate.length > 0) {
      // Show the zero-rate confirmation modal
      ModalService.showModal({
        template: require('../modals/confirm/template.html'),
        inputs: {
          details: {
            title: '',
            body: `Note: $0 default rates are not recommended. A user's default rate will be assigned unless another rate is specified. Therefore, a $0 default rate can result in time entries becoming ready to bill or even sent in invoices with $0 rates.`,
            confirmText: 'Save Anyway',
            rejectText: 'Cancel',
            showWarningIcon: true
          }
        },
        bodyClass: 'show-modal-overlay',
        controller: 'ConfirmModalController'
      }).then(modal => {
        modal.close.then(result => {
          if (result) {
            proceedWithSave(saveAllMatters);
          }
        });
      });
    } else {
      proceedWithSave(saveAllMatters);
    }
  };
  function proceedWithSave(saveAllMatters) {
    if (!validateOrigination()) {
      return;
    }
    const newType = $scope.matter.billing.type;
    const typeChanged = _initialBillingType !== newType && (_initialBillingType === 'hours' || newType === 'hours');
    if (newType === 'contingency') {
      $scope.matter.billing.contingency = $scope.matter.billing.contingency || {};
      $scope.matter.contingencyFeePercentage = $scope.matter.contingencyFeePercentage || null;
      $scope.matter.billing.contingency.noExpenseInterest = !$scope.expenseInterest;
    }
    let message = 'to reflect its new updated rate(s)';
    if (typeChanged) {
      if ($scope.matter.billing.type == 'hours') {
        message = 'to mark them billable';
      } else if (_initialBillingType == 'hours') {
        message = 'to mark them unbillable';
      }
    }
    if (!typeChanged && !_rateChanged) {
      return update(false, saveAllMatters);
    }

    // If the type changed, or any rate changed - ask to see if we need to update existing
    // time entries
    alerts.dismiss();
    ModalService.showModal({
      template: require('../modals/confirmUpdateEntries/template.html'),
      inputs: {
        message
      },
      bodyClass: 'show-modal-overlay',
      controller: 'ConfirmUpdateEntriesController'
    }).then(modal => {
      modal.close.then(result => {
        $scope.isBehindModal = false;
        if (!result) return;
        update(result.updateEntries, saveAllMatters).then(() => {
          const msg = saveAllMatters ? `All  ${$scope.me.terms.matter}s were updated` : `${$scope.me.terms.Matter} was updated`;
          alerts.success(msg);
        }).catch(err => {
          alerts.error(err);
        });
      });
    });
  }
  function update(updateEntries, saveAllMatters) {
    $scope.saving = true;
    const rateWasChanged = _rateChanged;
    const rateUpdate = {
      users: angular.copy($scope.matter.users),
      billing: {
        type: $scope.matter.billing.type,
        fees: angular.copy($scope.matter.billing.fees),
        contingency: angular.copy($scope.matter.billing.contingency)
      },
      restricted: $scope.matter.restricted,
      contingencyFeePercentage: $scope.matter.contingencyFeePercentage,
      rateOptions: {
        updateEntries: updateEntries
      }
    };
    function trackRateTableSave() {
      if (tracking && rateWasChanged && rateTableOpenTime) {
        const rateCount = $scope.matter.users?.filter(user => user.rate && user.rate.amount !== null && user.rate.amount !== undefined && user.rate.amount !== '').length || 0;
        const durationMs = Date.now() - rateTableOpenTime;
        userService.me().then(me => {
          tracking.event('Rate Table', 'Saved', {
            rateCount: rateCount,
            accountId: me.company?.id,
            entryPoint: 'matter',
            durationMs: durationMs,
            changedOnly: true
          });
        });
      }
    }
    const requestPromise = saveAllMatters ? leanLawApi.bulkUpdateMatterRates({
      clientId: $scope.matter.client.id,
      body: angular.extend({
        selectedMatterId: $scope.matter.id
      }, angular.copy(rateUpdate))
    }).then(response => {
      if (response?.selectedMatter) {
        return updateFormState(response.selectedMatter).then(() => {
          trackRateTableSave();
          return response;
        });
      }
      trackRateTableSave();
      return response;
    }) : leanLawApi.updateMatterRates({
      id: $scope.matter.id,
      body: rateUpdate
    }).then(matter => {
      return updateFormState(matter).then(() => {
        trackRateTableSave();
        return matter;
      });
    });
    return requestPromise.catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.saving = false;
    });
  }
  function updateFormState(matter) {
    return $scope.matter.load(matter, true).then(m => {
      $scope.billingForm.$setPristine();
      $scope.assignMatterToScope(m);
      _initialBillingType = m.billing.type;
      _rateChanged = false;
      if ($scope.enrichMatter) $scope.enrichMatter(m);
    });
  }
  $scope.cancel = function () {
    $scope.matter.reload().then(matter => {
      $scope.enrichMatter(matter);
      $scope.billingForm.$setPristine();
      $scope.showDisabledUsersTable = false;
      $scope.data.primary = $scope.matter.users.find(mu => mu.primary);
      $scope.assignMatterToScope(matter);
    });
  };
  $scope.quickbooks = function () {
    accountingService.verify(true).then(() => {
      $state.go('.connect', {
        id: $scope.matter.id
      });
    });
  };
  $scope.changeBillable = function (billable) {
    $scope.changing = true;
    leanLawApi.updateMatterEntries({
      id: $scope.matter.id,
      billable
    }).then(() => {
      alerts.success(`Changed all time entries to be ${billable ? '' : 'non-'}billable`);
      $scope.typeChanged = false;
    }).catch(alerts.error).finally(() => {
      $scope.changing = false;
    });
  };
  $scope.setRestricted = function (value) {
    $scope.matter.restricted = value;
    $scope.billingForm.$setDirty();
  };
  $scope.rateChange = function (user, isPrimary) {
    // if a new rate is typed in, we clear the label
    _rateChanged = true;

    // Check if the amount is valid
    if (!user.rate || user.rate.amount === null || user.rate.amount === undefined || user.rate.amount === '') {
      user.rate.error = "User's rate cannot be left blank";
      $scope.disabled = true;
    } else {
      $scope.disabled = false;
      user.rate.error = '';
      const amount = user.rate.amount;

      // Create new custom rate with unique _id
      const customRate = {
        label: '',
        amount: amount,
        isNew: true,
        _id: `${user.id}_rate_custom_${Date.now()}_${amount}`
      };

      // Add to rateList if not already present
      if (user.account && user.account.rateList) {
        // Remove any previous custom rates with empty label for this user
        user.account.rateList = user.account.rateList.filter(r => r.label !== '' || r.amount !== amount);
        // Add the new custom rate
        user.account.rateList.push(customRate);
      }

      // Use the same object reference
      user.rate = customRate;
    }
    if (isPrimary) {
      $scope.matter.users.find(u => u.primary).rate = user.rate;
    }
  };
  $scope.rateLabelChange = function (user) {
    _rateChanged = true;
  };
  $scope.removeUser = function (user) {
    if (user.primary) {
      alerts.warning(`You cannot remove ${$scope.primaryLabel}. Make someone else ${$scope.primaryLabel} first.`);
      return;
    }
    $scope.matter.users = $scope.matter.users.filter(u => u.id !== user.id);
    $scope.billingForm.$setDirty();
  };
  $scope.makePrimary = function (user) {
    if (user.account.role === 'accountant' || user.account.role === 'timekeeper') {
      alerts.warning(`Cannot make ${lists.userRoleFromId(user.account.role)} a ${$scope.primaryLabel} on ${$scope.me.terms.matter}s`);
      return;
    }
    $scope.matter.users = $scope.matter.users.map(mu => ({
      ...mu,
      primary: mu.id === user.id
    }));
    $scope.matter.primary = user.account;
    $scope.data.primary = $scope.matter.users.find(mu => mu.primary);
    $scope.billingForm.$setDirty();
  };
  $scope.addUser = function (account) {
    const user = {
      account,
      id: account.id,
      name: account.name,
      rate: {},
      active: true
    };

    // Prepare rates for Chosen dropdown tracking
    if (account.rateList) {
      // Add unique _id to each rate for Chosen's track-by
      account.rateList.forEach((rate, index) => {
        rate._id = rate._id || `${account.id}_rate_${index}_${rate.label}_${rate.amount}`;
      });
    }
    if (account.rates && !$scope.matter.rateGroup) {
      user.rate = {
        label: 'Standard',
        amount: account.rates.standard
      };
      // Sync with rateList object reference
      if (account.rateList) {
        const matchingRate = account.rateList.find(r => r.label === 'Standard' && r.amount === account.rates.standard);
        if (matchingRate) {
          user.rate = matchingRate;
        } else {
          user.rate._id = `${account.id}_rate_added_Standard_${account.rates.standard}`;
          account.rateList.push(user.rate);
        }
      }
    }
    if (account.rates && $scope.matter.rateGroup) {
      user.rate = {
        amount: $scope.matter.rateGroup?.rateGroupAccounts?.find(u => u.accountId === account.id).rate
      };
    }
    if (!$scope.matter.users.find(u => u.primary) && (account.role === 'lead' || account.role === 'principal')) {
      user.primary = true;
    }
    $scope.matter.users.push(user);
    $scope.data.newUser = null;
  };
  $scope.roleOrder = function (user) {
    if (!user.role) return user.name;
    if (user.role.id === 'primary') return 0;
    if (user.role.id === 'responsible') return 1;
    if (user.role.id === 'operator') return 2;
    if (user.role.id === 'other') return 3;
    return 3;
  };
  $scope.notPicked = function (user) {
    return !_.find($scope.matter.users, u => u.id === user.id);
  };
  $scope.originatingChanged = function (user) {
    user.origination = user.originating ? user.origination : null;
  };
  $scope.originationChange = function () {
    const total = $scope.matter.users.reduce((total, user) => {
      return total + (user?.origination || 0);
    }, 0);
    $scope.originationTotal = total;
    validateOrigination();
  };
  $scope.updateWIPRates = function () {
    if (!validateOrigination()) {
      return;
    }
    ModalService.showModal({
      template: require('../modals/confirm/template.html'),
      inputs: {
        details: {
          title: 'Confirm Update',
          body: 'This will update all time entries that are not on draft or billed invoices to the rates shown here.',
          confirmText: 'OK',
          rejectText: 'Cancel'
        }
      },
      bodyClass: 'show-modal-overlay',
      controller: 'ConfirmModalController'
    }).then(modal => {
      modal.close.then(result => {
        if (result) {
          $scope.updatingWIPRates = true;
          const path = `${$scope.domain}/matters/${$scope.matter.id}/wipRates`;
          const payload = {
            userRates: $scope.matter.users.map(u => ({
              id: u.id,
              rate: u.rate
            }))
          };
          $http.put(path, payload).then(() => {
            alerts.success('Successfully updated rates.');
          }).catch(err => {
            alerts.error(err);
          }).finally(() => {
            $scope.updatingWIPRates = false;
          });
        }
      });
    });
  };

  ///////////////////////////////////

  async function activate() {
    accountingService.verify().then(() => {
      $scope.accounting.connected = true;
    }).catch(() => {
      $scope.accounting.connected = false;
    });
    getRateGroup();
    await getInvoiceTemplates();
    userService.list().then(users => {
      $scope.data.users = users;
      function enrichMatter(matter) {
        if (!matter.billing) return;
        $scope.isSecondarySplitMatter = matter.isSecondarySplitMatter;
        if (matter.billing.fixed) {
          $scope.data.fixed = matter.billing.fixed;
        }
        $scope.activeUsers = $scope.data.users.filter(u => !u.disabled);
        matter.users.forEach(mu => {
          mu.active = !!$scope.activeUsers.find(u => u.id === mu.id);
          mu.account = $scope.data.users.find(u => u.id === mu.id);
          mu.defaultOrigination = origination(matter, mu);

          // Prepare rates for Chosen dropdown tracking
          if (mu.account?.rateList) {
            // Add unique _id to each rate for Chosen's track-by
            mu.account.rateList.forEach((rate, index) => {
              rate._id = rate._id || `${mu.id}_rate_${index}_${rate.label}_${rate.amount}`;
            });

            // Sync user's current rate with rateList object reference
            if (mu.rate && (mu.rate.label !== undefined || mu.rate.amount !== undefined)) {
              const matchingRate = mu.account.rateList.find(r => r.label === mu.rate.label && r.amount === mu.rate.amount);
              if (matchingRate) {
                mu.rate = matchingRate; // Use same object reference
              } else {
                // Add current rate to list if not found
                mu.rate._id = `${mu.id}_rate_loaded_${mu.rate.label}_${mu.rate.amount}`;
                mu.account.rateList.push(mu.rate);
              }
            }
          }
        });
        $scope.user = matter.users.find(u => u.id === $scope.me.id);
        $scope.data.primary = matter.users.find(u => u.primary);
        $scope.billingTypeLabel = lists.billingTypeFromId(matter.billing.type);
        _initialBillingType = matter.billing.type;
        $scope.billingTypes = lists.billingTypes;
        matter.invoiceTemplate = $scope.matter.invoiceTemplateId ? $scope.invoiceTemplates.find(t => t.invoiceTemplateId === $scope.matter.invoiceTemplateId) : {};
        if (matter.billing.type === 'contingency') {
          $scope.expenseInterest = !(matter.billing.contingency || {}).noExpenseInterest;
        }
        $scope.setInvoiceTemplateName();
      }
      $scope.enrichMatter = enrichMatter;
      $scope.$watch('matter', matter => {
        enrichMatter(matter);
      });
    });
    $scope.$watch('billingForm.$dirty', dirty => {
      $scope.$emit('matterBillingIsDirty', dirty);
    }, true);
    const deactivate = $rootScope.$on('$stateChangeStart', (event, transition) => {
      if ($scope.billingForm?.$dirty) {
        $scope.unsaved = true;
        $timeout(() => {
          $scope.unsaved = false;
        }, 4000);
        event.preventDefault();
      } else {
        deactivate();
      }
    });
  }
  async function getRateGroup() {
    try {
      const path = `${$scope.domain}/rategroups?format=settings`;
      const {
        data
      } = await $http.get(path);
      $scope.rateGroups = data;
    } catch (error) {
      this.alerts.error(error.response.data.message);
    }
  }
  async function getInvoiceTemplates() {
    try {
      const path = `${$scope.domain}/invoiceTemplates`;
      const {
        data
      } = await $http.get(path);
      $scope.invoiceTemplates = data;
    } catch (error) {
      this.alerts.error(error.response.data.message);
    }
  }
  $scope.showRateGroupModal = function () {
    ModalService.showModal({
      template: require('./views/matter-rate-group-modal.html'),
      inputs: {
        details: {
          title: 'Rate Group',
          body: 'Select a rate group to apply to all users.',
          confirmText: 'Save',
          rejectText: 'Cancel'
        },
        rateGroups: $scope.rateGroups,
        selectedRateGroup: $scope.matter.rateGroup || null,
        matter: $scope.matter,
        me: $scope.me
      },
      bodyClass: 'show-modal-overlay',
      controller: 'RateGroupModalController'
    }).then(modal => {
      modal.close.then(async result => {
        if (result) {
          $scope.matter.rateGroup = result.rateGroup;
          if (result.rateGroup) {
            const matter = await leanLawApi.getMatter({
              id: result.id
            });
            matter.users.forEach(updated => {
              const user = $scope.matter.users.find(u => u.id === updated.id);
              if (user) user.rate = updated.rate;
              if (updated.id == $scope.data.primary.id) {
                $scope.data.primary.rate = updated.rate;
              }
            });
          }
        }
      });
    });
  };
  $scope.showInvoiceTemplateModal = function () {
    ModalService.showModal({
      template: require('./views/matter-invoice-template-modal.html'),
      inputs: {
        details: {
          title: 'Invoice Template',
          body: 'Please choose the invoice template you wish to implement for this matter.',
          confirmText: 'Save',
          rejectText: 'Cancel'
        },
        invoiceTemplates: $scope.invoiceTemplates,
        selectedInvoiceTemplate: $scope.matter.invoiceTemplateId ? $scope.invoiceTemplates.find(t => t.invoiceTemplateId === $scope.matter.invoiceTemplateId) : null,
        matter: $scope.matter,
        me: $scope.me
      },
      bodyClass: 'show-modal-overlay',
      controller: 'InvoiceTemplateModalController'
    }).then(modal => {
      modal.close.then(async result => {
        if (result) {
          $scope.matter.invoiceTemplate = $scope.invoiceTemplates.find(t => t.invoiceTemplateId === result.invoiceTemplateId);
          $scope.matter.invoiceTemplateId = result.invoiceTemplateId;
          $scope.setInvoiceTemplateName();
        }
      });
    });
  };
  function origination(matter, mu) {
    const {
      report
    } = $scope.me.company.settings;
    if (!report) return undefined;
    if (report.accounts) {
      const originator = matter.users.find(u => u.originating);
      if (originator) {
        const reportUser = report.accounts.find(a => a.id === originator.id);
        if (reportUser) {
          if (mu.id === reportUser.id) {
            return reportUser.origination;
          }
          if (reportUser.referrals) {
            const referral = reportUser.referrals.find(r => r.id === mu.id);
            if (referral) {
              return referral.referral;
            }
          }
        }
      }
    }
    return mu.originating ? report.originatingContribution : undefined;
  }
  function validateOrigination() {
    if ($scope.originationTotal > 100) {
      alerts.error(`Sum of origination values cannot exceed 100!`);
      return false;
    }
    return true;
  }
}]);